(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-us-slider"]) return;
  try {
    
    document.addEventListener( 'DOMContentLoaded', function() {
        var targetCarouselContainer         = document.querySelector('#carousel_replace');
        var targetCarouselInner             = document.querySelector('#carousel_inner');
        targetCarouselContainer.appendChild(targetCarouselInner); 

        const slider                        = document.querySelector('.slider');
        const prevBtn                       = slider.querySelector('.slider__prev');
        const nextBtn                       = slider.querySelector('.slider__next'); 
        const indicator                     = slider.querySelector('#indicator'); 
        const progressBar                   = slider.querySelector('.slide_progress');

        const slider_main_img               = slider.querySelector('#slider_slide_main_image');
        const slider_year_img               = slider.querySelector('#slider_slide_year_image');
        const slider_year                   = slider.querySelector('#slider_year');
        const slider_description            = slider.querySelector('#slider_description');

        const slider_main_img_OVLERAY       = slider.querySelector('#slider_slide_main_image_OVERLAY');
        const slider_year_img_OVERLAY       = slider.querySelector('#slider_slide_year_image_OVERLAY');
        const slider_year_OVERLAY           = slider.querySelector('#slider_year_OVERLAY');
        const slider_description_OVERLAY    = slider.querySelector('#slider_description_OVERLAY');

        let currentSlide = 0;
        var funcRunning  = false;

        //onload, load slide 1
        slider_year.textContent         = carouselArray[currentSlide][0][1];
        slider_description.textContent  = carouselArray[currentSlide][1][1];

        slider_year_img.src             = carouselArray[currentSlide][2][1];

        slider_main_img.alt             = carouselArray[currentSlide][5][1];
        slider_main_img.src             = carouselArray[currentSlide][4][1];


        function slideCarousel() { 

            if (funcRunning != true){
                funcRunning = true;

                updateProgressBar();

                //add overlays
                slider_main_img_OVLERAY.src         = carouselArray[currentSlide][4][1];
                slider_main_img_OVLERAY.classList.add('carousel_ease_right_picture_OVERLAY');

                slider_year_img_OVERLAY.src         = carouselArray[currentSlide][2][1];
                slider_year_img_OVERLAY.classList.add('carousel_ease_up_OVERLAY');

                slider_description_OVERLAY.textContent     = carouselArray[currentSlide][1][1];
                slider_description_OVERLAY.classList.add('carousel_ease_right_text_OVERLAY');
                slider_year_OVERLAY.textContent            = carouselArray[currentSlide][0][1];
                slider_year_OVERLAY.classList.add('carousel_ease_right_text_OVERLAY');

                //add effects
                slider_year.classList.add('carousel_ease_right_text');
                slider_description.classList.add('carousel_ease_right_text');

                slider_main_img.classList.add('carousel_ease_right_picture');
                slider_year_img.classList.add('carousel_ease_up');

                //image & text
                setTimeout(() => {
                    slider_description.textContent  = carouselArray[currentSlide][1][1];
                    slider_year.textContent         = carouselArray[currentSlide][0][1];

                    slider_main_img.alt             = carouselArray[currentSlide][5][1];
                    slider_main_img.src             = carouselArray[currentSlide][4][1];
                }, 400);

                //year
                setTimeout(() => {
                    slider_year_img.src             = carouselArray[currentSlide][2][1];

                    slider_year.classList.remove('carousel_ease_right_text'); 
                    slider_description.classList.remove('carousel_ease_right_text'); 

                    //remove class from main image
                    slider_main_img.classList.remove('carousel_ease_right_picture'); 
                }, 501);//501 

                setTimeout(() =>{
                    slider_year_img.classList.remove('carousel_ease_up'); 
                }, 1000)

                //clear overlays
                setTimeout(() => {
                    slider_main_img_OVLERAY.classList.remove('carousel_ease_right_picture_OVERLAY');
                    slider_year_img_OVERLAY.classList.remove('carousel_ease_up_OVERLAY');

                    slider_description_OVERLAY.classList.remove('carousel_ease_right_text_OVERLAY');
                    slider_year_OVERLAY.classList.remove('carousel_ease_right_text_OVERLAY');
                    
                    funcRunning = false;
                }, 1001);
            }
            
        }

        console.log('501');

        prevBtn.addEventListener('click', sliderPrevBtn);
        nextBtn.addEventListener('click', sliderNextBtn);

        function sliderPrevBtn(){
            if (funcRunning != true){
                currentSlide = (currentSlide > 0) ? currentSlide - 1 : carouselArray.length - 1;
                slideCarousel();
            }
        }

        function sliderNextBtn(){
            if (funcRunning != true){
                currentSlide = (currentSlide < carouselArray.length - 1) ? currentSlide + 1 : 0;
                slideCarousel();
            }
        }



        const indicatorWidth = 1 / carouselArray.length;
        const percentage = indicatorWidth * 100 ;
        indicator.style.width = `${percentage}%`;
        progressBar.setAttribute('aria-valuemax', carouselArray.length);

        function updateProgressBar() {
            progressBar.setAttribute('aria-valuenow', currentSlide.toString());
            let currentMargin = ( (currentSlide) / carouselArray.length ) * 100;
            indicator.style.marginLeft = `${currentMargin}%`;
        }
        

    } );


  } catch(e) { console.error(e); }
})();
})();
